import { useCallback, useEffect } from 'react';

import { useNavigate } from 'react-router';

import { useGxTokenExpiryFromStorage, useGxTokenFromStorage } from '@/services/storage';

export const useTokenExpiry = () => {
  const navigate = useNavigate();
  const gxToken = useGxTokenFromStorage();
  const expiryTime = useGxTokenExpiryFromStorage();

  const isExpired = useCallback(() => {
    if (!expiryTime) return true; // No expiry set, treat as expired

    const now = Math.floor(Date.now() / 1000);
    const timeUntilExpiry = Number.parseInt(expiryTime) - now;

    return timeUntilExpiry <= 0;
  }, [expiryTime]);
  useEffect(() => {
    if (!gxToken) {
      return;
    }
    // Check immediately on mount
    if (isExpired()) {
      navigate('/logout');
      return;
    }

    // Check every minute
    const interval = setInterval(() => {
      if (isExpired()) {
        navigate('/logout');
      }
    }, 6000);

    return () => {
      clearInterval(interval);
    };
  }, [navigate, gxToken, isExpired()]);
};
